import { useState, useMemo } from 'react'

//Styles
import Styles from './bank-yang-digunakan.module.scss'

//Components
import TextMedium from 'pages/dashboard/e-reporting/forms/components/reuseables/text-medium'
import Order from 'pages/dashboard/e-reporting/forms/components/reuseables/order'
import WrapperAndBox from 'pages/dashboard/e-reporting/forms/components/reuseables/wrapper-and-box/WrapperAndBox'
import SelectWithSearch from 'pages/dashboard/e-reporting/forms/components/reuseables/select-with-search/SelectWithSearch'
import ButtonSelanjutnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-selanjutnya/ButtonSelanjutnya'
import ButtonSebelumnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-sebelumnya'
import BoxFlex from 'pages/dashboard/e-reporting/forms/components/reuseables/box-flex'

//Hoc
import withFetch from './withFetch'

//Context
import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

function BankYangDigunakan({ data }) {
  //Context
  const { setCurrentStep, formHandler, handlePrevState } = useFormMethod();
  const { isAprroval, form } = useFormState()

  //State
  const [selectedData, setSelectedData] = useState({
    ...form.bank_yang_digunakan.value,
    label: form.bank_yang_digunakan.value.name,
    value: form.bank_yang_digunakan.value.id
  })

  const mappedData = useMemo(() => {
    if (!data?.length) return [];
    return data.map(datum => {
      return {
        value: datum.id,
        label: datum.name,
        ...datum
      }
    })
  }, [data])

  const onNext = () => {
    handlePrevState()
    formHandler('bank_yang_digunakan', selectedData)
    if(form.metode_pembayaran.value.id === 2){
      setCurrentStep(STEPS.plafonKredit)
    } else {
      setCurrentStep(STEPS.totalKomisiMarketing)
    }
  }

  return (
    <WrapperAndBox>
      <div className={Styles['title']}>
        <TextMedium required>
          Bank yang digunakan
        </TextMedium>

      </div>
      <div className={Styles['select-wrapper']}>
        <SelectWithSearch selectedData={selectedData} disabled={isAprroval} onClick={setSelectedData} options={mappedData} placeholder="Pilih bank" />
        <BoxFlex>
          <>
            <ButtonSebelumnya />
            {!!selectedData && <ButtonSelanjutnya onClick={onNext} />}
          </>
        </BoxFlex>
      </div>
    </WrapperAndBox>
  )
}

export default withFetch(BankYangDigunakan)